import { useEffect } from 'react';


function TempDisable(props) {

  useEffect(() => {
    setTimeout(() => {
      props.setOrgShareElement(null);
    }, 600);
  }, []);


  return (
    <div class='flex-column'>
      <div class='has-text-centered' style={{paddingTop: '50px', paddingBottom: '50px'}}>
        <h3>Cuenta en Pausa</h3>
        <p>Dirígete por favor a tu escuela, para solicitar tu renovación.</p>
        <p>Gracias!</p>
      </div>
    </div>
  );
}

export default TempDisable;